import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Layout } from "antd";
import ProtectedRoute from "./ProtectedRoute";
import SideBaruser from "./sideBar";
import AdminDashboard from "../admin/adminDashboard";
import Login from "../loginadmin/login";
import BannerManagement from "../admin/bannerManagement/bannerManagement";
import UpdateBannerManagement from "../admin/bannerManagement/updateBannerManagement";
import AboutUsManagement from "../admin/aboutUsManagement/aboutUsManagement";
import UpdateAboutUsManagement from "../admin/aboutUsManagement/updateAboutUsManagement";
import CoreValues from "../admin/coreValues/corevalues";
import UpdateCorevalues from "../admin/coreValues/updateCorevalues";
import CustomerReview from "../admin/customerReviews/customerReview";
import OpeningHours from "../admin/openingHours/openingHours";
import UpdateOpeningHours from "../admin/openingHours/updateOpeningHours";
import ContactInformation from "../admin/contactInformation/contactInformation";
import UpdatecontactInformation from "../admin/contactInformation/updatecontactInformation";
import CategoryManagement from "../admin/categorymanagement/categoryManagement";
import Updatecategory from "../admin/categorymanagement/updatecategory";
import ProductManagement from "../admin/productmanagement/productManagement";
import UpdateProductManagement from "../admin/productmanagement/updateProductManagement";
import Bookingdata from "../admin/bookingData/bookingdata";
import ClientPage from "../admin/clientPage/clientPage";
import UpdateClientPage from "../admin/clientPage/updateClientPage";
import ContactMessages from "../admin/contactmessages/contactMessages";
import OfferManagement from "../admin/offerManagement/offerManagement";
import ViewActiveOffer from "../admin/offerManagement/viewActiveOffer";
import UpdateOffer from "../admin/offerManagement/updateOffer";
import SubcartegoryManagement from "../admin/categorymanagement/subcategory/subcartegoryManagement";
import UpdateSubcategory from "../admin/categorymanagement/subcategory/updateSubcategory";
import VideoManagement from "../admin/videoManagement/videoManagement";
import UpdateVideoManagement from "../admin/videoManagement/updateVideoManagement";

const AdminNavigation = () => {
  const user = useSelector((state: any) => state.user);
  const [collapsed, setCollapsed] = useState(false);
  const { Sider, Content } = Layout;
  return (
    <Layout>
      <Sider
        style={{ backgroundColor: "#FF1A1A", height: "100vh" }}
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={collapsed ? 40 : 250}
      >
        <SideBaruser
          collapsed={collapsed}
          doCollapse={() => setCollapsed(!collapsed)}
        />
      </Sider>
      <Content style={{ background: "#fff" }}>
        <Routes>
          {/* Redirect root (/) to /login if the user is not authenticated */}
          <Route path="/admin" element={<Login />} />

          <Route
            path="/adminDashboard"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminBanner"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <BannerManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminBanner/updatebanner/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateBannerManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminAabout"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <AboutUsManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminAabout/updateAboutUsManagement/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateAboutUsManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminCore"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <CoreValues />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminCore/updatecorevalues/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateCorevalues />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminCustomerReviews"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <CustomerReview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminOpeningHours"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <OpeningHours />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminOpeningHours/updateOpeningHours/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateOpeningHours />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminContactInformation"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <ContactInformation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminContactInformation/updatecontactinformation/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdatecontactInformation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminCategory"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <CategoryManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminSubCategory"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <SubcartegoryManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminSubCategory/updateSubcategory/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateSubcategory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminCategory/updatecategory/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <Updatecategory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminProduct"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <ProductManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminProduct/updateproduct/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateProductManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminBookingData"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <Bookingdata />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientdata"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <ClientPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientdata/updatedstatus/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateClientPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/contactmessages"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <ContactMessages />
              </ProtectedRoute>
            }
          />
          <Route
            path="/offerpage"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <OfferManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/viewActiveOffer"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <ViewActiveOffer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/offerpage/updateoffer/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateOffer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminVideoManagement"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <VideoManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/adminVideoManagement/updateVideoManagement/:id"
            element={
              <ProtectedRoute isSignedIn={user.isAuthenticated}>
                <UpdateVideoManagement />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Content>
    </Layout>
  );
};

export default AdminNavigation;
